var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.available)?_c('router-link',{staticClass:"workspace-link",attrs:{"to":{ name: 'OperatorWorkspace' },"title":"Общая очередь компаний"}},[_vm._v(" Рабочее место ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }